/** Yozish qadami (demo `step` → write): kataklar + yashirin input, `fold`/`lev` bilan tekshirish, xato bo'lsa `DiffMark`. */
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { fold, lev, LN, POS } from '../../../data';
import { t, tn } from '../../../i18n';
import { speak, speakSlow } from '../../../lib/speech';
import { Ic } from '../../../ui/Icon';
import { next, type Step } from '../engine';
import { answer, DiffMark, Frame, Prompt } from './common';

const clean = (x: string, n: number) => [...x.replace(/[^A-Za-zА-Яа-яЁё' -]/g, '').toLowerCase()].slice(0, n).join('');

export function WriteStep({ s }: { s: Step }) {
  const w = s.w!;
  const chars = [...w.w], n = chars.length, tt = fold(w.w);
  const [val, setVal] = useState('');
  const [focus, setFocus] = useState(false);
  const [done, setDone] = useState<string | null>(null); // tekshirilgan (fold) javob
  const inp = useRef<HTMLInputElement>(null);

  // Darhol (bosish bilan ochilgan klaviatura yopilmasidan) fokus; kechikkan urinish — zaxira
  useLayoutEffect(() => { inp.current?.focus({ preventScroll: true }); }, []);
  useEffect(() => {
    const a = setTimeout(() => { if (document.activeElement !== inp.current) inp.current?.focus({ preventScroll: true }); }, 60);
    const b = s.listen ? setTimeout(() => speak(w.w), 250) : undefined;
    return () => { clearTimeout(a); if (b) clearTimeout(b); };
  }, []); // eslint-disable-line

  const v = [...val];
  const cur = Math.min(v.length, n - 1);
  const check = () => {
    if (done !== null || v.length < n) return;
    const a = fold(val), d = lev(a, tt), ok = d === 0 || (d === 1 && tt.length > 4);
    setDone(a); inp.current?.blur();
    answer(w, ok, ok
      ? (d ? { ans: <span style={{ fontSize: 18, fontWeight: 700 }}>{t(`Imlo: ${w.w}`)}</span> } : {})
      : { ans: <DiffMark ans={a} correct={w.w} /> });
  };

  return (
    <Frame foot={<button className="btn" id="ck" disabled={v.length < n} onClick={check}>{t('Tekshirish')}</button>}>
      <Prompt retry={s.retry} text={s.listen ? 'Eshiting va ' + LN.adj + ' yozing' : LN.Adj + ' yozing'} />
      {s.listen ? (
        <div className="qcard" style={{ alignItems: 'center', gap: 12 }}>
          <div className="row g12">
            <button className="mic" id="pl" style={{ width: 76, height: 76 }} aria-label={t('Eshitish')} onClick={(e) => { e.preventDefault(); speak(w.w); }}><Ic n="vol" style={{ width: 32, height: 32 }} /></button>
            <button className="btn soft" id="slow" style={{ height: 44, width: 'auto', padding: '0 14px' }} onClick={(e) => { e.preventDefault(); speakSlow(w.w); }}>{t('Sekin')}</button>
          </div>
          <span className="t13" style={{ fontSize: 14 }}>{tn('# ta harf', n)}</span>
        </div>
      ) : (
        <div className="qcard"><b>{w.uz}</b><span className="t13" style={{ fontSize: 14 }}>{t(`${POS[w.pos] || ''} · ${n} ta harf`)}</span></div>
      )}
      <div className="col g8" style={{ alignItems: 'center', textAlign: 'center' }}>
        <span className="t13" style={{ fontWeight: 700 }}>{t('Javobingiz')}</span>
        <label className="cells" id="cells" htmlFor="in">
          {chars.map((c, i) => c === ' '
            ? <span key={i} className="gap" />
            : <span key={i} className={['cell', done !== null ? (done[i] === tt[i] ? 'good' : 'wrong') : (focus && i === cur ? 'cur' : ''), v[i] ? 'fill' : ''].filter(Boolean).join(' ')} data-i={i}>{v[i] || ''}</span>)}
          <input id="in" ref={inp} value={val} maxLength={n} readOnly={done !== null} autoComplete="off" autoCapitalize="off" autoCorrect="off" spellCheck={false}
            aria-label={tn('Javob, # ta harf', n)}
            onChange={(e) => setVal(clean(e.target.value, n))}
            onFocus={() => setFocus(true)} onBlur={() => setFocus(false)}
            onKeyDown={(e) => { if (e.key === 'Enter') { if (done !== null) next(); else check(); } }} />
        </label>
        <span className="t12">{t('Katakka bosib yozishni boshlang')}</span>
      </div>
    </Frame>
  );
}
